import React from 'react'
import { Heading } from 'components/util'

function Title (props) {
  return (
    <Heading {...props}
      topBar={true}
      bottomBar={true}
    />
  )
}

export default Title
